import React from 'react';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@mui/material';
import { AppDataGrid } from '@/components/ui';
import { UserDto } from '@cloudcost/shared-types/users';

interface UserDialogProps {
  open: boolean;
  onClose: () => void;
  users: UserDto[];
  onSelectUser: (userId: number) => void;
}

export const AddUserDialog: React.FC<UserDialogProps> = ({
  open,
  onClose,
  users,
  onSelectUser,
}) => {
  const columns = [
    { field: 'username', headerName: 'User name', flex: 1 },
    { field: 'firstName', headerName: 'First name', flex: 1 },
    { field: 'lastName', headerName: 'Last name', flex: 1 },
    { field: 'email', headerName: 'E-mail', flex: 1 },
    {
      field: 'actions',
      headerName: 'Actions',
      width: 90,
      renderCell: (params: any) => (
        <Button
          variant="contained"
          color="primary"
          size="small"
          onClick={() => onSelectUser(params.row.id)}>
          Add
        </Button>
      ),
    },
  ];

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="add-user-dialog-title"
      maxWidth="sm"
      fullWidth>
      <DialogTitle id="add-user-dialog-title">
        Add Tech User to Cloud Account
      </DialogTitle>
      <DialogContent>
        <Box sx={{ pt: 2 }}>
          <AppDataGrid
            rows={users}
            columns={columns}
            getRowId={(row) => row.id}
            initialState={{
              pagination: {
                paginationModel: { pageSize: 5, page: 0 },
              },
            }}
            sx={{ height: 400 }}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
      </DialogActions>
    </Dialog>
  );
};
